import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef012056"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address-form" }
const _hoisted_2 = {
  class: "el-dialog__body-footer abs",
  style: {"bottom":"-18px","left":"42px"}
}
const _hoisted_3 = {
  key: 0,
  style: {"margin-right":"20px","color":"red"}
}

import { t } from '@/plugins/i18n'
import type { FormInstance } from 'element-plus'
import { ref, toRaw, watch, computed } from 'vue'
import { cloneDeep } from 'lodash'
import { setDefaultForm } from '@/util/common'
import { updateShippingAddress, getOrderEditAddressApi } from '@/apis/order'
import useRules, { useMust, useRule } from '@/util/useRules'
import CommonDialog from '@/components/common/CommonDialog.vue'
import SortSelect from '@/components/common/SortSelect.vue'
import { getExpressAllCountryListApi } from '@/apis/user'
import { getAddressCodeName, getTotalCountryList, getAreaList } from '@/util/useCountry'
import { useSite2Station, isJA, isKO, isD2C, isEN, getWarehouseCode } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  form: {
    type: Object,
    default: () => ({})
  },
  platformOrderNo: {
    type: String,
    default: ''
  },
  isMultiStore: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible', 'success'],
  setup(__props, { emit: emits }) {

const props = __props



const defaultForm = {
  receiveName: '',
  email: '',
  country: '',
  postalCode: '',
  receiveTel: '',
  province: '',
  city: '',
  address: '',
  countryJp: '',
  provinceJp: '',
  cityJp: '',
  clearanceCode: ''
}

const getName = (code: string) => {
  if (code === 'JP' && isJA()) {
    return 'nameJa'
  }
  if (code === 'KR' && isKO()) {
    return 'nameKr'
  }
  return 'nameEn'
}
const rules = computed(() => {
  clearFomValidate()
  return {
    country: { message: t('国家不能为空'), required: true },
    receiveName: useRules({ message: t('收件人姓名不能为空'), key: 'deliver' }),
    province: useMust(t('都道府县不能为空'), 'change'),
    // cityJp: _form.value.countryCode === 'US' && isEN() ? useMust(t('市不能为空'), 'change') : undefined,
    city: _form.value.countryCode === 'US' ? useMust(t('市不能为空'), 'change') : undefined,
    email: useRules({ message: t('邮箱格式不正确，请重新输入'), key: 'email' }),
    address: useRules({ message: t('详细地址不能为空'), key: _form.value.country === '2115' ? 'address40' : 'address' }),
    receiveTel: useRules({ message: t('联系电话不能为空'), key: 'apiPhone' }),
    postalCode: useRules({ message: t('邮编不能为空'), key: _form.value.country === '2279' ? 'postal' : 'postalCode' }),
    clearanceCode: isKO() ? useRules({ message: t('通关码不能为空'), key: 'clearanceCode' }) : undefined
  }
})

const getForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultForm)
if (props.form.country === '+81') {
  props.form.country = t('日本')
}
const phoneCode = ref('')
// const getAreaTxt = (row: { province: any }) => {
//   const t: any = (props.provinces || []).find((e: any) => e.intAreaId === row.province)
//   return t?.label
// }

// const getCityTxt = (row: { province: any; city: any }) => {
//   const t: any = (props.provinces || []).find((e: any) => e.intAreaId === row.province)
//   if (t) {
//     const v = t.children.find((e: { intAreaId: any }) => e.intAreaId === row.city)
//     return v?.label
//   } else {
//     return ''
//   }
// }
const _form = ref(getForm(props.form))
const countryList = ref([])
_form.value.countryJp = _form.value.country
// _form.value.provinceJp = getAreaTxt(_form.value)
// _form.value.cityJp = getCityTxt(_form.value)
const submitLoading = ref(false)
const isCanEditAddress = ref(true) // 是否可以提交地址修改
const submit = () => {
  if (!addressRef.value) return
  addressRef.value.validate((valid) => {
    if (valid) {
      getOrderEditAddressApi({
        platformOrderNo: props.platformOrderNo
      }).then(async (res: any) => {
        console.log(res)
        isCanEditAddress.value = res.data
        if (res.data) {
          // submitLoading.value = true
          console.log(_form.value)
          const addressInfo: any = await getAddressCodeName({
            area: _form.value.province,
            city: _form.value.city,
            countryCode: _form.value.countryCode
          })
          console.log('addressInfo', addressInfo)
          // return
          updateShippingAddress({
            ...toRaw({
              ..._form.value,
              countryJp: addressInfo.countryItem[getName(addressInfo.countryItem.code)],
              cityJp: addressInfo.cityItem[getName(addressInfo.countryItem.code)],
              provinceJp: addressInfo.areaItem[getName(addressInfo.countryItem.code)],
              province: _form.value.province === '-' ? '' : _form.value.province,
              city: _form.value.city === '-' ? '' : _form.value.city,
              district: _form.value.district === '-' ? '' : _form.value.district,
              districtJp: _form.value.districtJp === '-' ? '' : _form.value.districtJp
            })
          }).then((res: any) => {
            if (res.success) {
              emits('update:visible', false)
              setTimeout(() => { submitLoading.value = false }, 1000)
              emits('success')
            } else {
              submitLoading.value = false
            }
          }).catch(() => { submitLoading.value = false })
        }
      })
    } else {
      return false
    }
  })
}
const cities: any = ref([])

const addressRef = ref<FormInstance>()
const allCountryList = ref([])
watch(() => props.visible, async (newValue) => {
  if (newValue) {
    if (props.form.country === '+81') {
      props.form.country = t('日本')
    }
    _form.value = getForm(props.form)
    // _form.value.countryJp = _form.value.country
    // _form.value.provinceJp = getAreaTxt(_form.value)
    // _form.value.cityJp = getCityTxt(_form.value)
    // setCities()
    if (!_form.value.province || _form.value.province === '-') {
      _form.value.province = _form.value.provinceJp
    }
    if (!_form.value.city || _form.value.city === '-') {
      _form.value.city = _form.value.cityJp
    }
    const totalCountry = await getTotalCountryList()
    allCountryList.value = totalCountry
    const countryItem = totalCountry.find((i: any) => i.intAreaId === _form.value.country)
    countryItem.areaNum && (phoneCode.value = '+' + countryItem.areaNum)
    countryItem.code && (_form.value.countryCode = countryItem.code)
    const isJp = countryItem.code === 'JP'
    provinces.value = [
      {
        intAreaId: _form.value.province,
        nameEn: isJp ? '' : _form.value.provinceJp,
        nameJa: isJp ? _form.value.provinceJp : '',
        nameKr: ''
      }
    ]
    cities.value = [
      {
        intAreaId: _form.value.city,
        nameEn: isJp ? '' : _form.value.cityJp,
        nameJa: isJp ? _form.value.cityJp : '',
        nameKr: ''
      }
    ]
    getAddressCodeName({
      countryCode: countryItem.code,
      area: _form.value.province,
      city: _form.value.city
    }).then((address: any) => {
      provinces.value = address.areaList
      cities.value = address.cityList
      // 如果省市是中文时匹配不出来结果
      if (_form.value.province && !address.areaItem.intAreaId) {
        const addressObj = {
          city: '',
          province: ''
        }
        address.areaList.forEach((item:any) => {
          if (_form.value.province === item.nameJa || _form.value.province === item.nameKr || _form.value.province === item.nameEn) {
            addressObj.province = item.intAreaId
            if (item.children?.length && _form.value.city) {
              item.children.forEach((temp:any) => {
                if (_form.value.city === temp.nameJa || _form.value.city === temp.nameKr || _form.value.city === temp.nameEn) {
                  addressObj.city = temp.intAreaId
                  cities.value = item.children
                }
              })
            }
          }
        })
        _form.value.province = addressObj.province
        _form.value.city = addressObj.city
      }
    })
    // 获取国家列表
    getExpressAllCountryListApi({
      intShipConfigId: props.form.intShipConfigId,
      stationCode: useSite2Station(),
      warehouseCode: getWarehouseCode(props.isMultiStore)
    }).then((res: any) => {
      const codes = res.data.map((i: any) => i.countryCode)
      countryList.value = totalCountry.filter((i: any) => codes.indexOf(i.code) > -1)
      console.log(countryList.value)
    })
  }
})

const provinces:any = ref([])
// 修改国家时重置省市
const changeCountry = (item: any) => {
  getAreaList(item).then((res: any) => {
    _form.value.province = res && res.length === 0 ? '-' : ''
    _form.value.city = ''
    _form.value.address = ''
    _form.value.postalCode = ''
    phoneCode.value = '+' + item.areaNum
    provinces.value = res
    cities.value = []
    _form.value.countryCode = item.code
    clearFomValidate()
  })
}
const changeArea = (item: any) => {
  console.log(item)
  _form.value.city = ''
  getAreaList(item).then((res: any) => {
    cities.value = res
  })
}
const clearFomValidate = () => {
  setTimeout(() => {
    addressRef.value && addressRef.value.clearValidate(['province', 'city', 'address', 'postalCode'])
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(CommonDialog, {
    "model-value": __props.visible,
    onCancel: _cache[8] || (_cache[8] = ($event: any) => (emits('update:visible', false))),
    draggable: "",
    className: "address-dialog",
    title: __props.title,
    footer: true,
    loading: submitLoading.value,
    disabled: !isCanEditAddress.value,
    cancelText: _unref(t)('取消'),
    okText: _unref(t)('确认'),
    onOk: submit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          ref: (_value, _refs) => {
            _refs['addressRef'] = _value
            addressRef.value = _value
          },
          rules: _unref(rules),
          model: _form.value,
          "label-width": "138px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('国/地区'),
              prop: "country"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(isJA)() ? allCountryList.value.find(v => v.intAreaId === _form.value.country)?.[_form.value.country === '2279' ? 'nameJa' :'nameEn'] || '-' : allCountryList.value.find(v => v.intAreaId === _form.value.country)?.nameEn), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('收件人'),
              prop: "receiveName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.receiveName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.receiveName) = $event)),
                  style: {"width":"400px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('电话'),
              prop: "receiveTel"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.receiveTel,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_form.value.receiveTel) = $event)),
                  style: {"width":"400px"}
                }, {
                  prepend: _withCtx(() => [
                    _createTextVNode(_toDisplayString(phoneCode.value || '-'), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('邮箱'),
              prop: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_form.value.email) = $event)),
                  style: {"width":"400px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _form.value.country === '2279' ? _unref(t)('都道府县') : _unref(t)('都道府県/州/地域'),
              prop: "province"
            }, {
              default: _withCtx(() => [
                _createVNode(SortSelect, {
                  value: _form.value.province,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_form.value.province) = $event)),
                  onChange: changeArea,
                  list: provinces.value,
                  type: "area",
                  rowKey: "intAreaId",
                  width: 400,
                  country: _form.value.country
                }, null, 8, ["value", "list", "country"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('市区町村'),
              prop: "city"
            }, {
              default: _withCtx(() => [
                _createVNode(SortSelect, {
                  value: _form.value.city,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_form.value.city) = $event)),
                  list: cities.value,
                  type: "area",
                  rowKey: "intAreaId",
                  width: 400,
                  country: _form.value.country
                }, null, 8, ["value", "list", "country"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('区町村-详细地址'),
              prop: "address"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  maxlength: 100,
                  modelValue: _form.value.address,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_form.value.address) = $event)),
                  style: {"width":"400px"},
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('邮编'),
              prop: "postalCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.postalCode,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_form.value.postalCode) = $event)),
                  style: {"width":"400px"},
                  maxlength: 20
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_unref(isKO)() && _unref(isD2C)())
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _unref(t)('个人通关码'),
                  prop: "clearanceCode"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _form.value.clearanceCode,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_form.value.clearanceCode) = $event)),
                      style: {"width":"400px"},
                      maxlength: 20
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        (!isCanEditAddress.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)('抱歉，订单正在打包中，不允许修改地址')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title", "loading", "disabled", "cancelText", "okText"]))
}
}

})